var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(-97 -85.268)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27032",
    "data-name": "Rectangle 27032",
    width: 24,
    height: 24,
    transform: "translate(97 85.268)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_40",
    "data-name": "Union 40",
    d: "M-7742,805.6c2-4.379,5.725-7.333,10-7.333s8,2.954,10,7.333c-2,4.38-5.725,7.333-10,7.333S-7740,809.982-7742,805.6Zm1.9,0c1.845,3.415,4.884,5.5,8.1,5.5s6.256-2.085,8.1-5.5c-1.845-3.415-4.883-5.5-8.1-5.5S-7738.256,802.187-7740.1,805.6Zm4.352,0a3.949,3.949,0,0,1,3.75-4.125,3.951,3.951,0,0,1,3.75,4.125,3.951,3.951,0,0,1-3.75,4.125A3.95,3.95,0,0,1-7735.75,805.6Zm1.667,0a2.194,2.194,0,0,0,2.083,2.292,2.195,2.195,0,0,0,2.083-2.292A2.195,2.195,0,0,0-7732,803.31,2.194,2.194,0,0,0-7734.083,805.6Z",
    transform: "translate(7841 -708)",
    fill: "rgba(255,255,255,0.7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e5ea4fe706166d576d7d01c1b0451709.svg";
export { ForwardRef as ReactComponent };